import React from 'react'
import Layout from '../../components/layout'
import PrepaidSidebar from '../../components/prepaid-sidebar'
import { StaticImage } from 'gatsby-plugin-image'
import Seo from '../../components/seo'

export default function Howto(): JSX.Element {
  return (
    <Layout>
      <Seo
        title={'使用方法｜トライアルプリペイドカード｜TRIAL -トライアル-'}
        description={
          'トライアルプリペイドカードのお会計方法とチャージ方法についてご紹介します。'
        }
        canonical={'https://www.trial-net.co.jp/prepaid/howto/'}
      />
      <div className="howto">
        <div className="howto-title-wrapper">
          <h1 className="howto-title">
            トライアル
            <br className="sp-new-line" />
            プリペイドカード
          </h1>
        </div>
        <div className="howto-container">
          <article className="howto-main">
            <h2 className="howto-main__title">使用方法</h2>
            <section className="howto-main__semi-self">
              <h3 className="howto-main__semi-self-title">セミセルフレジ</h3>
              <div className="howto-main__line" />
              <section className="howto-main__pay">
                <h4 className="howto-main__pay-title">お会計方法</h4>
                <p className="howto-main__pay-lead">
                  セミセルフレジの機種により、カード読み取り方法が2種類ございます。
                </p>
                <div className="semi-self-howto">
                  <div className="semi-self-howto__item">
                    <StaticImage
                      src="../../images/howto_no01.png"
                      alt=""
                      className="semi-self-howto__item-number-img"
                    />
                    <StaticImage
                      src="../../images/howto_img01.png"
                      alt=""
                      className="semi-self-howto__item-img"
                    />
                    <p className="semi-self-howto__item-text">
                      「プリカ」を押します。
                    </p>
                  </div>
                  <div className="semi-self-howto__item">
                    <StaticImage
                      src="../../images/howto_no02.png"
                      alt=""
                      className="semi-self-howto__item-number-img"
                    />
                    <div className="semi-self-howto__box">
                      <div className="semi-self-howto__box-item">
                        <StaticImage
                          src="../../images/howto_img02.png"
                          alt=""
                          className="semi-self-howto__item-img"
                        />
                        <p className="semi-self-howto__item-text">
                          スリットにカードを通します。
                        </p>
                        <p className="semi-self-howto__item-text--sm">
                          ※表面を左側に向け、磁気面を下にする
                        </p>
                      </div>
                      <p className="semi-self-howto__item-text--or">OR</p>
                      <div className="semi-self-howto__box-item">
                        <StaticImage
                          src="../../images/howto_img03.png"
                          alt=""
                          className="semi-self-howto__item-img"
                        />
                        <p className="semi-self-howto__item-text">
                          挿入口に入れます。
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="semi-self-howto__item">
                    <StaticImage
                      src="../../images/howto_no03.png"
                      alt=""
                      className="semi-self-howto__item-number-img"
                    />
                    <StaticImage
                      src="../../images/howto_img04.png"
                      alt=""
                      className="semi-self-howto__item-img"
                    />
                    <p className="semi-self-howto__item-text">
                      レシートをお取りください。
                    </p>
                  </div>
                </div>
              </section>
              <section className="howto-main__charge">
                <h4 className="howto-main__charge-title">
                  チャージ方法（残高不足の場合）
                </h4>
                <p className="howto-main__charge-lead">
                  ご精算の際に、プリペイドカードの残高が不足している場合、以下の方法でチャージできます。
                </p>
                <div className="charge-howto">
                  <div className="charge-howto__item-wrapper">
                    <div className="charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no01.png"
                        alt=""
                        className="charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img01.png"
                        alt=""
                        className="charge-howto__item-img"
                      />
                      <p className="charge-howto__item-text">
                        「プリカ」を押します。
                      </p>
                    </div>
                    <div className="charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no02.png"
                        alt=""
                        className="charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img05.png"
                        alt=""
                        className="charge-howto__item-img"
                      />
                      <p className="charge-howto__item-text">
                        チャージ金額を選択し「チャージ」を押します。
                      </p>
                    </div>
                    <div className="charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no03.png"
                        alt=""
                        className="charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img06.png"
                        alt=""
                        className="charge-howto__item-img"
                      />
                      <p className="charge-howto__item-text">
                        お金を投入します。
                      </p>
                    </div>
                    <div className="charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no04.png"
                        alt=""
                        className="charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img07.png"
                        alt=""
                        className="charge-howto__item-img"
                      />
                      <p className="charge-howto__item-text">
                        金額を確認して「レシート」を押します。その後、上記の
                        <strong>お会計方法の3</strong>
                        へと続いていきます。
                      </p>
                    </div>
                    <div className="charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no05.png"
                        alt=""
                        className="charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img08.png"
                        alt=""
                        className="charge-howto__item-img--lg"
                        objectFit={'contain'}
                      />
                      <p className="charge-howto__item-text">
                        完了となります。
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </section>
            <section className="howto-main__self">
              <h3 className="howto-main__self-title">セルフレジ</h3>
              <div className="howto-main__line" />
              <section className="howto-main__self-pay">
                <h4 className="howto-main__self-pay-title">お会計方法</h4>
                <p className="howto-main__self-pay-lead">
                  商品のバーコードを読み取り完了後、以下の操作を行ってください。
                </p>
                <div className="self-pay-howto">
                  <div className="self-pay-howto__item-wrapper">
                    <div className="self-pay-howto__item">
                      <StaticImage
                        src="../../images/howto_no01.png"
                        alt=""
                        className="self-pay-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img01.png"
                        alt=""
                        className="self-pay-howto__item-img"
                      />
                      <p className="self-pay-howto__item-text">
                        「トライアルプリカ」を押します。
                      </p>
                    </div>
                    <div className="self-pay-howto__item">
                      <StaticImage
                        src="../../images/howto_no02.png"
                        alt=""
                        className="self-pay-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img03.png"
                        alt=""
                        className="self-pay-howto__item-img"
                      />
                      <p className="self-pay-howto__item-text">
                        挿入口に入れます。
                      </p>
                    </div>
                    <div className="self-pay-howto__item">
                      <StaticImage
                        src="../../images/howto_no03.png"
                        alt=""
                        className="self-pay-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img07.png"
                        alt=""
                        className="self-pay-howto__item-img"
                      />
                      <p className="self-pay-howto__item-text">
                        「はい」を押します。
                      </p>
                    </div>
                    <div className="self-pay-howto__item">
                      <StaticImage
                        src="../../images/howto_no04.png"
                        alt=""
                        className="self-pay-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img09.png"
                        alt=""
                        className="self-pay-howto__item-img"
                      />
                      <p className="self-pay-howto__item-text">
                        カードを取ります。
                      </p>
                    </div>
                    <div className="self-pay-howto__item">
                      <StaticImage
                        src="../../images/howto_no05.png"
                        alt=""
                        className="self-pay-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img08.png"
                        alt=""
                        className="self-pay-howto__item-img--lg"
                        objectFit={'contain'}
                      />
                      <p className="self-pay-howto__item-text">
                        完了となります。
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section className="howto-main__self-charge">
                <h4 className="howto-main__self-charge-title">チャージ方法</h4>
                <p className="howto-main__self-charge-lead">
                  セルフレジでは、以下の方法でチャージできます。
                </p>
                <div className="self-charge-howto">
                  <div className="self-charge-howto__item-wrapper">
                    <div className="self-charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no01.png"
                        alt=""
                        className="self-charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img10.png"
                        alt=""
                        className="self-charge-howto__item-img"
                      />
                      <p className="self-charge-howto__item-text">
                        「プリカチャージ」を押します。
                      </p>
                    </div>
                    <div className="self-charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no02.png"
                        alt=""
                        className="self-charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img03.png"
                        alt=""
                        className="self-charge-howto__item-img"
                      />
                      <p className="self-charge-howto__item-text">
                        挿入口に入れます。
                      </p>
                    </div>
                    <div className="self-charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no03.png"
                        alt=""
                        className="self-charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img05.png"
                        alt=""
                        className="self-charge-howto__item-img"
                      />
                      <p className="self-charge-howto__item-text">
                        チャージ金額を選択して「OK」を押します。
                      </p>
                    </div>
                    <div className="self-charge-howto__item">
                      <StaticImage
                        src="../../images/howto_no04.png"
                        alt=""
                        className="self-charge-howto__item-number-img"
                      />
                      <StaticImage
                        src="../../images/howto_img11.png"
                        alt=""
                        className="self-charge-howto__item-img"
                      />
                      <p className="self-charge-howto__item-text">
                        お金を投入して、「チャージ」を押して完了。
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </section>
            <section className="howto-main__normal">
              <h3 className="howto-main__normal-title">通常レジ</h3>
              <div className="howto-main__line" />
              <section className="normal-pay-howto">
                <h4 className="normal-pay-howto__title">お会計方法</h4>
                <div className="normal-pay-howto__box">
                  <div className="normal-pay-howto__box-item">
                    <p className="normal-pay-howto__text--bold">
                      レジにてお支払いの際に
                      <br className="pc-new-line" />
                      「電子マネーで」とお申し付けください。
                    </p>
                    <p className="normal-pay-howto__text">
                      お会計終了後、トライアルプリペイドカードをお返しいたします。
                    </p>
                    <p className="normal-pay-howto__text--sm">
                      ※お支払いの際、電子マネーの残高が足りない場合は、レジにてチャージすることも可能です。また、不足分を現金にてお支払いいただくことも可能です。
                    </p>
                  </div>
                  <StaticImage
                    src="../../images/howto_img12.png"
                    alt=""
                    className="normal-pay-howto__img"
                    objectFit={'contain'}
                  />
                </div>
              </section>
              <section className="normal-charge-howto">
                <h4 className="normal-charge-howto__title">チャージ方法</h4>
                <div className="normal-charge-howto__box">
                  <div className="normal-charge-howto__box-item">
                    <p className="normal-charge-howto__text">
                      お会計時に、レジで「○○円チャージ」とお申し付け頂き
                      <strong>トライアルプリペイドカード</strong>と
                      <strong>現金</strong>をお渡しください。
                    </p>
                  </div>
                  <StaticImage
                    src="../../images/howto_img13.png"
                    alt=""
                    className="normal-charge-howto__img"
                    objectFit={'contain'}
                  />
                </div>
              </section>
            </section>
            <section className="howto-main__notes">
              <h2 className="howto-main__notes-title">
                チャージ（ご入金）についての注意事項
              </h2>
              <div className="howto-main__line--blue" />
              <div className="notes">
                <p className="notes__text">
                  電子マネーのチャージは下記場所でも行えます。
                </p>
                <StaticImage
                  src="../../images/howto_img14.png"
                  alt=""
                  className="notes__pc-img"
                  objectFit={'contain'}
                />
                <StaticImage
                  src="../../images/howto_img15.png"
                  alt=""
                  className="notes__sp-img"
                  objectFit={'contain'}
                />
                <div className="notes__list-wrapper">
                  <ul className="notes__list">
                    <li className="notes__list-item">
                      <strong className="notes__list-item-blue-text">
                        1,000円単位
                      </strong>
                      でチャージできます
                    </li>
                    <li className="notes__list-item">
                      一回で
                      <strong className="notes__list-item-blue-text">
                        49,000円まで
                      </strong>
                      チャージできます。
                    </li>
                    <li className="notes__list-item">
                      <strong className="notes__list-item-blue-text">
                        総額100,000円まで
                      </strong>
                      チャージできます。
                    </li>
                  </ul>
                  <ul className="notes__list">
                    <li className="notes__list-item">
                      チャージ後はいかなる場合も
                      <strong className="notes__list-item-blue-text">
                        返金できません。
                      </strong>
                    </li>
                    <li className="notes__list-item">
                      チャージには
                      <strong className="notes__list-item-blue-text">
                        金券類はご利用できません。
                      </strong>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          </article>
          <PrepaidSidebar />
        </div>
      </div>
    </Layout>
  )
}
